module.exports = __webpack_public_path__ + "img/icon_wx.81d5bdea.jpg";